import React, { useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { MasterConfigs } from '../../../../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { postData, putData } from '../../../../../actions/developer';
import { constants } from '../../../../../constants/common';
import NextRoundModal from '../../tabs/Screening/modal';
import FormSetup from '../../../../../components/Forms/FormSetup';

const Approval = () => {
  const level = constants.PROFILE_STATUS.APPROVAL;
  const [nextRound, setNextRound] = useState(false)
  const [candidateType, setCandidateType] = useState(null)
  const [selected, setSelectedRow] = useState([])
  const [sendForm, setSendForm] = useState(false)
  const [selectedRow, setSelected] = useState<any>({})
  const dispatch = useDispatch();

  const OverriddenConfig: MasterConfigs = {
    ...ShortListedConfig,
    api: () => ShortListedConfig.api() + '/' + level,
    tableProps: {
      rowSelection: {
        ...ShortListedConfig.rowSelection,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRow(selectedRows)
        },
      },
    },
    isActionTab: true,
    actions: [...ShortListedConfig.actions, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
    getColumns: () => [
      ...ShortListedConfig.getColumns(),
    ]
  };

  const formConfig: MasterConfigs = {
    api: () => ShortListedConfig.api() + '/book',
    modalTitle: () => 'Send Request Form',
    onSubmit: async (id, data) => {
      sendLink({ ids: selectedRow._id, ...data });
      return { code: 200, message: 'Success' }
    },
    onRefresh: () => {
      setSelected(null)
      setSendForm(false)
    },
    getFormColumns: () => [
      {
        label: 'Form',
        name: 'form',
        type: 'select',
        rules: [{ required: true, message: 'Please select form' }],
        isCombo: true
      }
    ],
    combo: [
      {
        api: '/doccument-folders',
        name: 'form',
        idKey: '_id',
        render: (item) => {
          return <div>{item.name}</div>
        }
      }
    ]
  }

  const confirmationlink = async (item) => {
    setSelected(item)
    setSendForm(true)
  }

  const sendLink = async (item) => {
    const resData = await dispatch(postData(ShortListedConfig.api() + '/' + level + '/send/doccument/request', item));
    if (resData) {
      onRefresh()
    }
  }

  const onOfferedCTC = async (text, item) => {
    if (text != item.offeredCTC) {
      const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item._id, { offeredCTC: text }));
      if (resData) {
        onRefresh()
      }
    }
  }

  const onRefresh = () => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true
    })
  }


  const onMoveToNext = () => {
    setNextRound(true)
  }

  return <React.Fragment>
    <FormSetup config={formConfig} open={sendForm} onClose={() => {
      setSelected(null)
      setSendForm(false)
    }} isModal={true} id={selectedRow?._id} />
    <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
    <MasterComponent config={OverriddenConfig} />
  </React.Fragment>
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Approval);
